import Base from 'netxcore@netx/core-app/views/appFullScreenView';

export default class AppFullScreenView extends Base {
	/** @override */
	afterHidden(view) {
		super.afterHidden(view);
		this.$el.removeClass('in');
	}

	/** @override */
	beforeShown(view) {
		this.$el.addClass('in');
		super.beforeShown(view);
	}
}
